import React, { useState, useEffect } from "react";
import moment from "moment";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import Toolbar from "@mui/material/Toolbar";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { useTheme } from "@mui/material/styles";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import { Link, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../global";
import Tooltip from "@mui/material/Tooltip";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { getUsers } from "../../utils/databaseHelper";
import { Autocomplete, Box, TextField } from "@mui/material";
import ListWrap from "../commonComponent/listWrap";

// datatablse packages
var $ = require("jquery");
$.DataTable = require("datatables.net");

const columns = [
  { id: "id", label: "Sr. No." },
  { id: "companyName", label: "Client ", minWidth: 40 },
  { id: "address", label: "Address ", minWidth: 40 },
  { id: "outChallanNo", label: "Challan Number", minWidth: 40 },
  { id: "outwardDate", label: "OutWard Date ", minWidth: 40 },
];

function createData(id, clientId, companyName, address,outChallanNo, outwardDate) {
  return {
    id,
    clientId,
    companyName,
    address,
    outChallanNo,
    outwardDate,
  };
}

export default function ChallanList() {
  const [page, setPage] = React.useState(0);
  const urlPath = useLocation();
  const [searchBy, setSearchBy] = React.useState(
    sessionStorage.getItem("searchBy") || "Challan_Number"
  );
  const [searchKey, setSearchKey] = React.useState(
    sessionStorage.getItem("searchKey") || ""
  );
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);

  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [challanList, setChallanList] = React.useState([]);
  const [stInOutData, setStInOutData] = React.useState([]);
  const [totalCount, setTotalCount] = React.useState(0);
  const [editAccess, setEditAccess] = React.useState(
    localStorage.getItem("editAccess")?.split(",").map(Number)
  );
  const [searched, setSearched] = React.useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const submitSiteDelete = (outChallanNo) => {
    let url = BASE_URL;
    let query = {
      query: `UPDATE standardInOutChallan SET status = -1 WHERE outChallanNo = '${outChallanNo}'`,
    };
    axiosWithToken
      .post(url + `dynamic`, query)
      .then((res) => {
        toast("Deleted standard In/Out!");
        setTimeout(refresh, 1000);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };
    const TablePaginationActions = (props) => {
      const theme = useTheme();
      const { count, page, rowsPerPage, onPageChange } = props;
  
      const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
      };
  
      const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
      };
  
      const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
      };
  
      const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
      };
  
      return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
          <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label="first page"
          >
            {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
          <IconButton
            onClick={handleBackButtonClick}
            disabled={page === 0}
            aria-label="previous page"
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
          </IconButton>
          <IconButton
            onClick={handleNextButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="next page"
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </IconButton>
          <IconButton
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="last page"
          >
            {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>
        </Box>
      );
    };

  const getWhereConditions = () => {
    let whereConditions = "";

    if (searchBy !== "" && searchKey !== "") {
      let colName = {
        Challan_Number: "si.outChallanNo",
      }[searchBy];
      whereConditions = `where LOWER(${colName}) like LOWER('%${searchKey}%')`;
    }

    
    if (whereConditions == "") {
      whereConditions += " where si.status = 1  ";
    } else {
      whereConditions += " and si.status = 1  ";
    }

    return whereConditions;
  };

  const getData = () => {
    let whereConditions = getWhereConditions();
    let pagination_settings = "";

    if (rowsPerPage !== -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

    let data = {
      query: `SELECT DISTINCT si.outChallanNo, si.outwardDate, cl.companyName, a.address FROM standardInOutChallan AS si LEFT JOIN clients AS cl ON si.clientId = cl.id LEFT JOIN addresses AS a ON a.id = si.address ${whereConditions} order by si.id DESC ${pagination_settings}`,
    };
    return data;
  };

  const getCountData = () => {
    let whereConditions = getWhereConditions();
    
    let data = {
      query: `SELECT COUNT(DISTINCT si.outChallanNo) as total FROM standardInOutChallan AS si LEFT JOIN clients AS cl ON si.clientId = cl.id LEFT JOIN addresses AS a ON a.id = si.address ${whereConditions}`,
    };
    return data;
  };

  const getChallanList = () => {
    const data = getData();
    const countData = getCountData();

    // Fetch count
    axiosWithToken
      .post(BASE_URL + `dynamic`, countData)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setTotalCount(res.data[0].total);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // Fetch data
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setChallanList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const initializeStInOutData = () => {
    var rowDaata = [];
    for (let i = 0; i < challanList.length; i++) {
      rowDaata.push(
        createData(
          challanList[i].id,
          challanList[i].clientId,
          challanList[i].companyName,
          challanList[i].address,
          challanList[i].outChallanNo,
          challanList[i].outwardDate
            ? moment(challanList[i].outwardDate).format("DD-MM-YYYY")
            : ""
        )
      );
    }
    setStInOutData(rowDaata);
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if (storedSearchBy) {
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    setSearched(true);
    setPage(0); // Reset to first page on search
    getChallanList();
  };
  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched", searched);
    sessionStorage.removeItem("currentPath");
    setSearchBy("");
    setSearchKey("");
    setFrom(null);
    setTo(null);
    setSearched(false);
    setPage(0); // Reset to first page
  };

  useEffect(() => {
    if (searched == false) {
      getChallanList();
    }
  }, [searched]);

  useEffect(() => {
    getChallanList();
  }, [page, rowsPerPage]);

  useEffect(() => {
    initializeStInOutData();
  }, [challanList]);

  return (
    <ListWrap>
      <Toolbar style={{ padding: "0px" }}>
        <Button
          variant="contained"
          size="small"
          component={Link}
          to="/editChallan/0"
          sx={{
            ":hover": {
              color: "#fff",
            },
          }}
        >
          <b>ADD Challan</b>
        </Button>
      </Toolbar>
      <div
        className="mb-2"
        style={{
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        <Autocomplete
          sx={{
            m: 0,
            minWidth: 180,
          }}
          className="Listinputcss"
          size="small"
          id="combo-box-demo"
          value={searchBy}
          options={[{ key: "si.outChallanNo", label: "Challan_Number" }]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(event, newInputValue) => {
            setSearchBy(newInputValue);
            setSearched(false);
          }}
        />

        <TextField
          id="outlined-basic"
          inputProps={{
            autoComplete: "off",
          }}
          label={"enter " + searchBy}
          size="small"
          className="Listinputcss"
          variant="outlined"
          value={searchKey}
          onChange={(e) => {
            setSearchKey(e.target.value);
            setSearched(false);
          }}
          sx={{ marginLeft: "10px" }}
        />
        <Button
          variant="contained"
          size="small"
          sx={{ m: 0 }}
          color={searched ? "error" : "primary"}
          style={{ marginLeft: "10px" }}
          onClick={() => {
            searched ? clearSearch() : search();
          }}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </div>
      <TableContainer>
        <Table
          stickyHeader
          aria-label="sticky table"
          size="small"
          sx={{ borderCollapse: "collapse" }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  <b>{column.label}</b>
                </TableCell>
              ))}
              <TableCell>
                <b>Actions</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stInOutData?.length > 0 ? (
              stInOutData.map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                      {columns.map((column) => {
                        let value = row[column.id];

                        if (column.id == "id") {
                          value = page * rowsPerPage + index + 1;
                        }
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}

                      <TableCell>
                        <ButtonGroup
                          size="small"
                          aria-label="small button group"
                        >
                          <Tooltip title="Edit Challan" placement="top-start">
                            <Button
                              style={{
                                borderColor: "#dc3545",
                              }}
                              component={Link}
                              to={`/editChallan/${encodeURIComponent(row.outChallanNo)}`}
                            >
                              <PreviewIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Delete Challan" placement="top-start">
                            <Button
                              onClick={(e) => {
                                if (
                                  window.confirm(
                                    "Really want to delete challan?"
                                  )
                                ) {
                                  submitSiteDelete(row.outChallanNo);
                                }
                              }}
                              disabled={
                                !(
                                  editAccess?.includes(2) ||
                                  editAccess?.includes(0)
                                )
                              }
                              style={{
                                borderColor: "#dc3545",
                              }}
                            >
                              <DeleteIcon
                                style={{
                                  color: !(
                                    editAccess?.includes(2) ||
                                    editAccess?.includes(0)
                                  )
                                    ? "lightgray"
                                    : "#dc3545",
                                }}
                              />
                            </Button>
                          </Tooltip>
                        </ButtonGroup>
                      </TableCell>
                    </TableRow>
                  );
                })
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                  <h6>
                    <b>Data Not Found</b>
                  </h6>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[10, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
        <ToastContainer />
      </TableContainer>
    </ListWrap>
  );
}
